class BisNotify {


  API_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';

  subscribeElement = document.querySelector('.notify_modal_subscribe');
  resultSuccessElement = document.querySelector('.notify_modal_success');
  modal = document.querySelector('.notify_modal');
  closeButtons = document.querySelectorAll('.notify_modal_close');
  openButton = document.querySelector('.notify_modal_open');

  constructor() {
    this.init();
  }


  init() {
    const form = document.querySelector('.bis-notify-form');

    if (form) {

      this.initControls();
      this.initValidation(form);

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const email = new FormData(form).get('email');
        if (!this.validateEmail(email)) {
          this.showInvalidEmailMessage(form);
          return;
        }

        const url = this.createUrl(form);
        const payload = this.createPayload(form);
        this.doRequest(url, payload);
      });
    }
  }


  initValidation(form) {
    form.querySelector('input[type="email"]').addEventListener('blur', (event) => {
      const email = event.target.value;
      if (!this.validateEmail(email)) {
        this.showInvalidEmailMessage(form);
        return;
      }
      this.hideInvalidEmailMessage(form);
    });
  }

  showInvalidEmailMessage(form) {
    const validationBox = form.querySelector('.valiation_box_email');
    validationBox.classList.add('invalid');
  }

  hideInvalidEmailMessage(form) {
    const validationBox = form.querySelector('.valiation_box_email');
    validationBox.classList.remove('invalid');
  }

  validateEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  initControls() {


    this.closeButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', (event) => {
        this.closeModal();
      });
    });

    this.openButton.addEventListener('click', (event) => {
      this.modal.classList.add('active');
    });
  }

  createUrl(form) {
    const formData = new FormData(form);
    return this.API_ENDPOINT + '?company_id=' + formData.get('company_id');
  }


  createPayload(form) {
    const formData = new FormData(form);
    return {
      'data': {
        'type': 'back-in-stock-subscription', 'attributes': {
          'profile': {
            'data': {
              'type': 'profile', 'attributes': {
                'email': formData.get('email')
              }
            }
          }, 'channels': ['EMAIL']
        }, 'relationships': {
          'variant': {
            'data': {
              'type': 'catalog-variant', 'id': '$shopify:::$default:::' + formData.get('variant_id')
            }
          }
        }
      }
    };
  }

  handleResponse(response) {
    if (response.status === 202) {
      this.showSuccessMessage();
    }
  }


  showSuccessMessage() {
    this.subscribeElement.classList.remove('active');
    this.resultSuccessElement.classList.add('active');
  }

  revertToSubscribe() {
    this.subscribeElement.classList.add('active');
    this.resultSuccessElement.classList.remove('active');
  }

  closeModal() {
    this.modal.classList.remove('active');
    this.revertToSubscribe();
  }


  doRequest(url, payload) {
    var requestOptions = {
      method: 'POST', headers: {
        'Content-Type': 'application/json', 'revision': '2024-06-15'
      }, body: JSON.stringify(payload)
    };

    fetch(url, requestOptions)
      .then(result => this.handleResponse(result))
      .catch(error => console.log('error', error));
  }
}

window.addEventListener('DOMContentLoaded', (event) => {
  new BisNotify();
});